export default __webpack_public_path__ + "static/media/10.965ea864.webp";